var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGripHorizontalFourLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,7H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Zm0,4H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Zm0,4H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Zm0,4H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripHorizontalFourLines);
export default __webpack_public_path__ + "static/media/grip_horizontal_four_lines.ffc7cdc14133bea37920d7f973c38491.svg";
export { ForwardRef as ReactComponent };